// Make per-instance colour actually reach the pixel (three 0.135).
//
// THE BUG THIS FIXES
//
// Every per-element colour in the streaming viewer - the diff overlay's
// green/amber/blue/red, the grey GHOST tint that drops the rest of the
// model back, the selection highlight - is written into an InstancedMesh's
// `instanceColor` buffer (InstanceStateApplicator). three 0.135 ships a
// HALF-WIRED version of that feature:
//
//   color_vertex.glsl.js        vColor is declared and multiplied by
//                               instanceColor under USE_INSTANCING_COLOR
//   color_pars_fragment.glsl.js vColor is declared ONLY under USE_COLOR
//   color_fragment.glsl.js      diffuseColor is multiplied by vColor
//                               ONLY under USE_COLOR
//
// So on any material with `vertexColors: false` - which is every fragment
// GLB the exporter writes without a COLOR_0 attribute, i.e. most of them -
// the vertex shader computes the tint and the fragment shader throws it
// away. The store said 813 of 815 elements were ghosted and the model on
// screen did not change by one pixel.
//
// Upstream fixed exactly this in r137 by extending both fragment chunks to
// `USE_COLOR || USE_INSTANCING_COLOR`. This file is that patch, applied to
// the ShaderChunk registry at import time - which is why it is imported at
// the top of webgl/js/app/app.js, before any material is compiled.
//
// Why not turn `vertexColors` on instead: USE_COLOR makes the shader read
// a `color` attribute, and geometry that has none gets the WebGL default
// (0,0,0) - a black model. Giving every fragment a white COLOR_0 buffer
// would cost three floats per vertex across the whole building for a
// feature the instance buffer already provides.
//
// Safe by construction: instanceColor is initialised to white (1,1,1) for
// every slot (GlobalInstancePool._build), so an instance nobody has
// tinted multiplies by 1 and renders exactly as it did before. Materials
// that DO carry vertexColors already took the USE_COLOR path and are
// untouched.
import { ShaderChunk, REVISION } from "three";

// The r137 chunks below were back-ported for three 0.135; from r137 on
// three handles instanceColor itself and its chunks changed shape, so
// the override must not run there.
if (parseInt(REVISION, 10) < 137) {


ShaderChunk.color_pars_fragment = /* glsl */`
#if defined( USE_COLOR_ALPHA )

	varying vec4 vColor;

#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )

	varying vec3 vColor;

#endif
`;

ShaderChunk.color_fragment = /* glsl */`
#if defined( USE_COLOR_ALPHA )

	diffuseColor *= vColor;

#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )

	diffuseColor.rgb *= vColor;

#endif
`;


}

export default true;
